<script lang="ts">
import type { Snippet } from 'svelte'
import type { HTMLAttributes } from 'svelte/elements'

type Props = {
	children?: Snippet
} & HTMLAttributes<HTMLDivElement>

let { children, ...rest }: Props = $props()
</script>

<div class="text-sm leading-4.5 color-slate-500 break-words {rest.class || ''}">{@render children?.()}</div>
